












































































import { Component, Vue, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import QDatePicker from '@/components/Booking/QDatePicker.vue';
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';

dayjs.extend(minMax);

@Component({
  components: {
    QDatePicker,
  },
  computed: {
    ...mapState('ServiceOrder', {
      newBulkServiceOrder: 'newBulkServiceOrder',
    }),
  },
})
export default class ServiceOrderCreatePaymentDetailsTable extends Vue {
  @Prop({ default: true }) readonly selectedBusiness!: Model;
  newBulkServiceOrder!: ServiceOrderState['newBulkServiceOrder'];

  agreements = 1;

  get totalOrderDetailsAmount() {
    if (!this.selectedBusiness) {
      return 0;
    }
    return this.$store.getters['ServiceOrder/totalOrderDetailsAmount'](
      this.selectedBusiness.gst_rate_applied
    );
  }

  get totalPaymentDetailsAmount() {
    if (!this.selectedBusiness) {
      return 0;
    }
    return this.$store.getters['ServiceOrder/totalPaymentDetailsAmount'](
      this.selectedBusiness.gst_rate_applied
    );
  }

  beforeMount() {
    this.agreements =
      this.newBulkServiceOrder.payment_details.length ?? this.agreements;

    if (!_.isEmpty(this.paymentDetails)) {
      return;
    }
    this.paymentDetails = [
      {
        due_date: null,
        amount:
          Math.round(
            this.totalOrderDetailsAmount /
              (1 + this.selectedBusiness.gst_rate_applied)
          ) / 2,
      },
      {
        due_date: null,
        amount:
          Math.round(
            this.totalOrderDetailsAmount /
              (1 + this.selectedBusiness.gst_rate_applied)
          ) / 2,
      },
    ];
  }

  get headers() {
    const header = [
      { text: 'To be Raised Date', value: 'due_date', sortable: false },
      {
        text: 'Amount (' + this.selectedBusiness.gst_label_applied + ' excl.)',
        value: 'amount',
        align: 'right',
        sortable: false,
      },
      {
        text: this.selectedBusiness.gst_label_applied,
        value: 'gst',
        align: 'right',
        sortable: false,
      },
      { text: 'Total', value: 'total', align: 'right', sortable: false },
      { text: 'Action', value: 'action', sortable: false },
    ];

    return header;
  }

  get paymentDetails() {
    return this.newBulkServiceOrder.payment_details;
  }
  set paymentDetails(v) {
    this.$store.commit('ServiceOrder/SET_NEW_BULK_SERVICE_ORDER', {
      ...this.newBulkServiceOrder,
      payment_details: v,
    });
  }

  addPaymentDetail() {
    this.paymentDetails.push({
      due_date: null,
      amount: 0,
    });
  }

  removePaymentDetail(i) {
    this.paymentDetails.splice(i, 1);
  }

  setUnitPrice(value, i) {
    if (value < 0) {
      this.paymentDetails[i].amount = 0;
    } else {
      this.paymentDetails[i].amount = value * 100;
    }
  }

  get isTotalPaymentDetailsAmountTooBig() {
    return this.totalOrderDetailsAmount - this.totalPaymentDetailsAmount < 0;
  }

  get isTotalPaymentDetailsAmountTooSmall() {
    return this.totalOrderDetailsAmount - this.totalPaymentDetailsAmount > 0;
  }

  getTooBigAmountErrorMessages() {
    if (this.isTotalPaymentDetailsAmountTooBig) {
      return ['The sum of the amount is greater than the total amount.'];
    }

    if (this.isTotalPaymentDetailsAmountTooSmall) {
      return ['The sum of the amount is less than the total amount.'];
    }
    return [];
  }

  preventNumberSpecialKeys(event) {
    // ., -, +
    if ([43, 45, 46].includes(event.keyCode)) {
      event.preventDefault();
    }
  }

  getMinDate(i) {
    const dueDates = this.paymentDetails
      .filter((item) => item.due_date)
      .map((item) => dayjs(item.due_date));

    const minDate = dayjs.min(dueDates);

    // if the payment due date is same as the min_date or min_date is null, use today as the min_date
    if (!minDate || dayjs(this.paymentDetails[i].due_date).isSame(minDate)) {
      return dayjs()
        .add(1, 'day')
        .format('YYYY-MM-DD');
    }

    return minDate.add(1, 'day').format('YYYY-MM-DD');
  }
}
